var xP = require('../xP')
  , $ = require('jquery');

module.exports = {
  name: 'valid', base: '_rooted', prototype: {
    init: function (params, control) {
      this._.root_type = 'invalid';
      if ($.type(params) === 'regexp') {
        params = params.toString();
      }
      if ($.type(params) === 'string' && params.indexOf('/') === 0) {
        params = '[this].val().match(' + params + ')';
      }

      xP.dependencies.valid.base.init.apply(this, arguments);
    },

    process: function () {
      xP.debug(
        'valid', 'valid', this.result, this.to.first().$element, this.to
      );

      var that = this;

      this.to.each(function () {
        // TODO: Избавиться бы от проверки типа.
        var value = this.val();
        if (
          !value && value !== 0
          && !(this instanceof xP.controls.fields)
        ) {
          this.$container
            .removeClass(that.container_valid_class)
            .removeClass(that.container_invalid_class);

          that.result = true;
        } else {
          xP.dependencies.valid.base.process.apply(that);

          if (that.result) {
            this.$container
              .addClass(that.container_valid_class)
              .removeClass(that.container_invalid_class);
          } else {
            this.$container
              .removeClass(that.container_valid_class)
              .addClass(that.container_invalid_class);
          }
        }
      });

      this.to_root(!this.result);
    },

    container_valid_class: 'valid',
    container_invalid_class: 'invalid'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/dependencies/valid.js
 ** module id = 47
 ** module chunks = 0
 **/